import React, { useEffect, useState } from "react";
// import MLRStatusGreen from "../../../images/MLR StatusGreen.png";
// import MLRStatusGray from "../../../images/MLR StatusGray.png";
// import MLRStatusRed from "../../../images/MLR StatusRed.png";
import MLRWarning from "../../../images/MLR-Warning-Grey.svg";
import MLRExpired from "../../../images/MLR-Expired.svg";
import MLROrange from "../../../images/MLRStatus-Intermediate-Orange.svg";
import MLRDraft from "../../../images/MLR_Draft.svg";
import MLRGreen from "../../../images/MLR-GreenTick.svg";
import MLRStatusOrange from "../../../images/common_status.svg";
import refreshIcon from "../../../images/gilead-refresh-icon.svg";
import TimeIcon from "../../../images/time-icon.svg";
import BlueCheckBox from "../../../images/bluecheckbox.svg";
// import CrossIcon from "../../../images/clearTextIcon.svg";
// import CloseIcon from "../../../images/Close-Small.svg";
// import SuccessIcon from "../../../images/Success-Icon.svg";
// import ErrorIcon from "../../../images/Error-Icon.svg";
import CircularProgressBar from "../../../utils/CircularProgressBar";
import "../../../css/newBannerDesign.scss";
import { daysAgoCreated } from "../../../utils";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { ExportDeckToMail, geteDetailByID,getMLRStatus } from "../../../services/apis";
import PreviewModal from "../../Preview/Preview";
import { showErrorToast } from "../../toastComponent/ToastComponent";
import navigator from "../../../images/Navigator.svg"
import NewPreviewModal from "../../Preview/NewPreviewModal";
import { getColor } from "../../../constant/veeva";

const SelectTemplateCard = ({ 
  cardData, 
  imageKey, 
  templateSelected,
  setshowFetchedResults,
  showFetchedResults, 
  setTemplatedSelected, 
  setPayloadData, 
  payloadData, 
  isOneTimeContent, 
  countriesList,
  brandsList,
}) => {
  const [imageLoader, setImageLoader] = useState(true);
  const [previewLoading, setPreviewLoading] = useState(false);
    const [appDataTemp, setAppDataTemp] = useState({});
    const [showPreviewModal, setShowPreviewModal] = useState(false);
  

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));
  const imageLoaded = (thumbnail) => {
    if (thumbnail) {
      setImageLoader(false);
    } else {
      setImageLoader(true);
    }
  };
    const validStatusRegex = (status) => {
      const regex = /^(Approved for (Use|Production))$/i;
      const countryValidRegex = /^(GRC Process Complete)$/i;
    if (regex.test(status) || countryValidRegex.test(status)) {
    
      return true
    }else{return false}
  }

  const creationDay = () => {
    const createdOn = cardData?.created_at;
    return daysAgoCreated(createdOn);
    };
    const templateSelection = (card) => {
      setTemplatedSelected((prev) => {
        const isSelected = prev.includes(card._id);
        if (isSelected) {
          setPayloadData((prevPayload) => {
            const { id, default_aspect_ratio, ...rest } = prevPayload;
            return rest;
          });
          return [];
        } else {
          setPayloadData((prevPayload) => ({
            ...prevPayload,
            id: card._id,
            default_aspect_ratio: card?.default_aspect_ratio
          }));
          return [card._id];
        }
      }
      )
  }
  
  const previewClick = async (e) => {
    e.stopPropagation();
    setPreviewLoading(true);
    await geteDetailByID(
      // cardData.cardData._id,
      cardData._id,
      async (response, err, errorCode) => {
        if (err) {
          setPreviewLoading(false);
          showErrorToast(`Preview Failed. ${err}`);
        } else {
          let data = await response.data;
          setAppDataTemp({ ...appDataTemp, deckId: data });
          ExportDeckToMail(
            cardData._id,
            (response, err, errorCode) => {
              if (err) {
                setPreviewLoading(false);
                showErrorToast(`Preview Failed. ${err}`);
                setShowPreviewModal(false);
              } else {
                setShowPreviewModal(true);
                setPreviewLoading(false);
              }
            },
            "preview=true"
          );
        }
      })
    //
    
  }
  const getCurrentStatus = () => {
    setPreviewLoading(true);

    getMLRStatus(cardData._id, true, async (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
        if (typeof err.response.data.err === "string")
          showErrorToast('The document is not yet submitted');
        else
          showErrorToast('Something went wrong. Try again.!');
      } else {
        setPreviewLoading(false);
        let data = await response.data;

        let index = showFetchedResults.findIndex(
          (result) => result._id === cardData._id
        );
        let tempAllDecks = JSON.parse(JSON.stringify(showFetchedResults));
        cardData.veevaMetadata[0].statusMLR = data.response.statusMLR;
        tempAllDecks[index] = cardData;
        setshowFetchedResults(tempAllDecks);
      }
    });
  };
  useEffect(() => {
   //setAppDataTemp({...appDataTemp, deckId:cardData}) 
  },[]);

  return (
    <>
      {previewLoading && (
        <CircularProgressBar
          isloading={previewLoading}
          setIsloading={setPreviewLoading}
        />
      )}
      <div className={`cards-container cards-container-template ${templateSelected?.includes(cardData._id)?'active-card':''}`} style={{ height: "248px", position:'relative'}} onClick={()=>templateSelection(cardData)}>
        {templateSelected.includes(cardData._id) && <img src={BlueCheckBox } width={20} height={20} className="selected-temp"/>}
        <div className="img-container" style={isOneTimeContent && {border:"1px solid #DDDFDD", borderTopLeftRadius:"4px", borderTopRightRadius:"4px"}}>
          <img
            src={
              cardData?.slides[0]?.slideid?.thumbnail !== ""
                ? `${cardData?.slides[0]?.slideid?.thumbnail}?n=${imageKey}` //cardData?.slides[0]?.slideid?.thumbnail
                : "https://fujifilm-x.com/wp-content/uploads/2019/08/x-t30_sample-images02.jpg"
            }
            alt=""
            key={imageKey}
            className={`img-overlay card-img ${
              cardData.expired ? "img-grayScale" : ""
            }`}
            //ref={cardRef}
            onLoad={() => imageLoaded(cardData?.slides[0]?.slideid?.thumbnail)}
          />
        </div>
        { isOneTimeContent ? (
          <div className="cards-details-OTC">
            <div>
              <div className="cards-details-OTC-status d-flex" style={{height: '24px'}}>
                <div className="cards-details-docID" style={{background:"#E1EDDA"}}>
                  <LightTooltip
                    className="mlrToolTip"
                    title={
                      cardData?.veevaMetadata?.length > 0
                            ? cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0].docStatus
                            : "Not Submitted"
                    }
                    arrow
                  >
                    <img
                      src={
                            
                            validStatusRegex(cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus)
                              ? MLRGreen
                              : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Draft"
                              ? MLRDraft
                              : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Not Submitted"
                              ? MLRDraft
                              : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Pending Withdrawal"
                              ? MLRWarning
                              : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Withdrawn"
                              ? MLRWarning
                              : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Expired"
                              ? MLRExpired
                              :cardData?.veevaMetadata?.length > 0
                              ? MLRStatusOrange
                              : MLRDraft
                              
                          
                      }
                      alt="MLR Icon"
                      className="statusIcon"
                    />
                  </LightTooltip>
                  <p className="module-list-card-moduleName">{cardData?.veevaMetadata[0]?.docNumber||"-"}</p>
                  {/* <a href={cardData?.veevaMetadata[0]?.docLink}  target="_blank"style={{lineHeight:"10px"}}>
                    <img src={navigator} width={16} height={16}/>
                  </a> */}
                </div>
                {/* <img
                  src={refreshIcon}
                  alt="refreshIcon"
                  onClick={() => getCurrentStatus()}
                  className="refreshIcon"
                /> */}
              </div>
              <div className="d-flex gap-3">
                <div className="d-flex">
                  <div className="cards-details-OTC-label">Product:&nbsp;</div>
                  <div className="cards-details-OTC-value" style={{width: '42px'}}>{ brandsList?.find(country => country._id == cardData.brand)?.name || 'NA'}</div>
                </div>
                <div className="d-flex">
                  <div className="cards-details-OTC-label">Country:&nbsp;</div>
                  <div className="cards-details-OTC-value" style={{width: '42px'}}>{ countriesList?.find(country => country._id == cardData.market)?.name || 'NA'}</div>
                </div>
              </div>
              <div className="d-flex">
                <div className="cards-details-OTC-label">Name:&nbsp;</div>
                <div className="cards-details-OTC-value">{cardData?.name}</div>
              </div>
            </div>
            <div className="d-flex align-items-center created-time" style={{marginTop: '5px'}}>
              <div className="time-icon-container">
                <img src={TimeIcon} alt="refreshIcon" className="refreshIcon"  />
                <p className="module-list-card-product-name">{creationDay()}</p>
              </div>
              <div className="view-div" onClick={(e)=>previewClick(e)}>VIEW</div>
            </div>
          </div>
        ) : (
          <div className="cards-details">
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center" style={{ backgroundColor: getColor(cardData?.veevaMetadata?.length > 0 && cardData?.veevaMetadata?.filter((asset)=> asset?.assetType === 1)[0]?.docStatus), borderRadius: "6px", padding: "2px 2px 2px 8px" }}>
                <LightTooltip
                  className="mlrToolTip"
                  title={
                    cardData?.veevaMetadata?.length > 0
                          ? cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0].docStatus
                          : "Not Submitted"
                  }
                  arrow
                >
                  <img
                    height={16}
                    src={
                          
                          validStatusRegex(cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus)
                            ? MLRGreen
                            : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Draft"
                            ? MLRDraft
                            : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Not Submitted"
                            ? MLRDraft
                            : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Pending Withdrawal"
                            ? MLRWarning
                            : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Withdrawn"
                            ? MLRWarning
                            : cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docStatus === "Expired"
                            ? MLRExpired
                            :cardData?.veevaMetadata?.length > 0
                            ? MLRStatusOrange
                            : MLRDraft
                            
                        
                    }
                    alt="MLR Icon"
                    className="statusIcon"
                  />
                </LightTooltip>
              <p className="module-list-card-moduleName">{cardData?.veevaMetadata[0]?.docNumber||"-"}</p>
              </div>
              {/* <img
                src={refreshIcon}
                alt="refreshIcon"
                onClick={() => getCurrentStatus()}
                className="refreshIcon"
              /> */}
            </div>
            <div className="d-flex align-items-center" style={{marginTop: '8px'}}>
              <div className="d-flex align-items-center">
                <h4 className="module-list-card-product-name">Product:</h4>
                <h2 className="module-list-card-product-content" style={{width: '63px'}}>
                  <LightTooltip
                    className="mlrToolTip"
                    title={
                      brandsList?.filter((brand) => brand?._id === cardData?.brand)[0]
                        ?.name || ""
                    }
                    arrow
                  >
                    <span>
                      {brandsList?.filter((brand) => brand?._id === cardData?.brand)[0]
                        ?.name || ""}
                    </span>
                  </LightTooltip>
                </h2>
              </div>
              <div className="d-flex align-items-center">
                <h4 className="module-list-card-product-name">Country:</h4>
                <h2 className="module-list-card-product-content" style={{width: '63px !important'}}>
                  <LightTooltip
                    className="mlrToolTip"
                    title={
                      countriesList?.filter((brand) => brand?._id === cardData?.market)[0]
                        ?.name || ""
                    }
                    arrow
                  >
                    <span>
                      {countriesList?.filter((brand) => brand?._id === cardData?.market)[0]
                        ?.name || ""}
                    </span>
                  </LightTooltip>
                </h2>
              </div>
            </div>
             <div className="d-flex align-items-center" style={{marginTop: '8px'}}>
              <h4
                className="module-list-card-product-name"
                style={{ width: "auto" }}
              >
                Name{" "}
              </h4>
              <h4 className="separator-colon" style={{ margin: 0 }}>
                :
              </h4>
              <h2 className="module-list-card-product-content">
                {cardData?.name.length > 14 ? (
                  <LightTooltip className="mlrToolTip" title={cardData?.name} arrow>
                    <span>{cardData?.name}</span>
                  </LightTooltip>
                ) : (
                  cardData?.name
                )}
              </h2>
            </div>
            <div className="d-flex align-items-center created-time" style={{marginTop: '5px'}}>
              <div className="time-icon-container">
                <img src={TimeIcon} alt="refreshIcon" className="refreshIcon"  />
                <p className="module-list-card-product-name">{creationDay()}</p>
              </div>
              <div className="view-div" onClick={(e)=>previewClick(e)}>VIEW</div>
            </div>
          </div>
        )}
      
      </div>
      {/* {showPreviewModal && (
              <PreviewModal
                showPreview={showPreviewModal}
                setShowPreView={setShowPreviewModal}
                deckData={cardData}
                slideID={appDataTemp.deckId.slides}
                currentSlide={{ master: appDataTemp.deckId.slides[0], child: {} }}
                lastChild={{}}
                inParent={{}}
                //canvasHeight={canvasHeight}
                appData={appDataTemp}
                previewUrlReady={true}
              />
            )} */}
        {showPreviewModal && (
          <NewPreviewModal
            showPreview={showPreviewModal}
            setShowPreView={setShowPreviewModal}
            deckData={cardData}
            slideID={appDataTemp.deckId.slides}
            currentSlide={{ master: appDataTemp.deckId.slides[0], child: {} }}
            lastChild={{}}
            inParent={{}}
            //canvasHeight={canvasHeight}
            appData={appDataTemp}
            previewUrlReady={true}
          />
        )}
      </>
  );
};
export default SelectTemplateCard;
